export const reportsCategories = {
  US_CATEGORIES : [
    {
      categoryName: 'Property Capsule Report',
      name: 'Property Capsule Report',
      title: 'Property Capsule Report',
      report_request_data: {
        report_name: 'PROPERTY_CAPSULE_REPORT'
      }
    },
    {
      categoryName: 'Business',
      value: [
        {
          name: 'business_loc',
          title: 'Business Locator',
          report_request_data: {
            report_name: 'BUSINESS_LOCATOR'
          }
        },
        {
          name: 'business_summary',
          title: 'Business Summary',
          report_request_data: {
            report_name: 'BUSINESS_SUMMARY'
          }
        },
        {
          name: 'shopping',
          title: 'Major Shopping Center Locator',
          report_request_data: {
            report_name: 'MAJOR_SHOPPING_CENTER_LOCATOR'
          }
        },
        {
          name: 'retail_market',
          title: 'Retail MarketPlace Profile',
          report_request_data: {
            report_name: 'RETAIL_MARKETPLACE_PROFILE'
          }
        }
      ]
    },
    {
      categoryName: 'Consumer Spending',
      value: [
        {
          name: 'cex_auto',
          title: 'Automotive Aftermarket Expenditures',
          report_request_data: {
            report_name: 'AUTOMOTIVE_AFTERMARKET_EXPENDITURES'
          }
        },
        {
          name: 'cex_financial',
          title: 'Financial Expenditures',
          report_request_data: {
            report_name: 'FINANCIAL_EXPENDITURES'
          }
        },
        {
          name: 'cex_home',
          title: 'House and Home Expenditures',
          report_request_data: {
            report_name: 'HOUSE_HOME_EXPENDITURES'
          }
        },
        {
          name: 'cex_budget',
          title: 'Household Budget Expenditures',
          report_request_data: {
            report_name: 'HOUSEHOLD_BUDGET_EXPENDITURES'
          }
        },
        {
          name: 'cex_medical',
          title: 'Medical Expenditures',
          report_request_data: {
            report_name: 'MEDICAL_EXPENDITURES'
          }
        },
        {
          name: 'cex_recreation',
          title: 'Recreation Expenditures',
          report_request_data: {
            report_name: 'RECREATION_EXPENDITURES'
          }
        },
        {
          name: 'cex_retail',
          title: 'Retail Goods and Services Expenditures',
          report_request_data: {
            report_name: 'RETAIL_GOODS_SERVICES_EXPENDITURES'
          }
        }
      ]
    },
    {
      categoryName: 'Demographics',
      value: [
        {
          name: 'census2010_profile',
          title: '2010 Census Profile',
          report_request_data: {
            report_name: 'CENSUS_2010_PROFILE'
          }
        },
        {
          name: 'acs_housing',
          title: 'ACS Housing Summary',
          report_request_data: {
            report_name: 'ACS_HOUSING_SUMMARY'
          }
        },
        {
          name: 'acs_population',
          title: 'ACS Population Summary',
          report_request_data: {
            report_name: 'ACS_POPULATION_SUMMARY'
          }
        },
        {
          name: '55plus',
          title: 'Age 50+ Profile',
          report_request_data: {
            report_name: 'AGE_50_PLUS_PROFILE'
          }
        },
        {
          name: 'agesex',
          title: 'Age by Sex Profile',
          report_request_data: {
            report_name: 'AGE_BY_SEX_PROFILE'
          }
        },
        {
          name: 'agesexrace',
          title: 'Age by Sex by Race Profile',
          report_request_data: {
            report_name: 'AGE_BY_SEX_BY_RACE_PROFILE'
          }
        },
        {
          name: 'community_profile',
          title: 'Community Profile',
          report_request_data: {
            report_name: 'COMMUNITY_PROFILE'
          }
        },
        {
          name: 'dandicomparison',
          title: 'Demographic and Income Comparison Profile',
          report_request_data: {
            report_name: 'DEMOGRAPHIC_INCOME_COMPARISON_PROFILE'
          }
        },
        {
          name: 'dandi',
          title: 'Demographic and Income Profile',
          report_request_data: {
            report_name: 'DEMOGRAPHIC_INCOME_PROFILE'
          }
        },
        {
          name: 'agedet',
          title: 'Detailed Age Profile',
          report_request_data: {
            report_name: 'DETAILED_AGE_PROFILE'
          }
        },
        {
          name: 'dispinc',
          title: 'Disposable Income Profile',
          report_request_data: {
            report_name: 'DISPOSABLE_INCOME_PROFILE'
          }
        },
        {
          name: 'execsummary',
          title: 'Executive Summary',
          report_request_data: {
            report_name: 'EXECUTIVE_SUMMARY'
          }
        },
        {
          name: 'graphic',
          title: 'Graphic Profile',
          report_request_data: {
            report_name: 'GRAPHIC_PROFILE'
          }
        },
        {
          name: 'hh_income',
          title: 'Household Income Profile',
          report_request_data: {
            report_name: 'HOUSEHOLD_INCOME_PROFILE'
          }
        },
        {
          name: 'housing',
          title: 'Housing Profile',
          report_request_data: {
            report_name: 'HOUSING_PROFILE'
          }
        },
        {
          name: 'market_profile',
          title: 'Market Profile',
          report_request_data: {
            report_name: 'MARKET_PROFILE'
          }
        },
        {
          name: 'networth',
          title: 'Net Worth Profile',
          report_request_data: {
            report_name: 'NET_WORTH_PROFILE'
          }
        }
      ]
    },

    {
      categoryName: 'Market Potential',
      value: [
        {
          name: 'mpi_pc',
          title: 'Electronics and Internet Market Potential',
          report_request_data: {
            report_name: 'ELECTRONICS_INTERNET_MARKET_POTENTIAL'
          }
        },
        {
          name: 'mpi_investment',
          title: 'Finances Market Potential',
          report_request_data: {
            report_name: 'FINANCES_MARKET_POTENTIAL'
          }
        },
        {
          name: 'mpi_health',
          title: 'Health and Beauty Market Potential',
          report_request_data: {
            report_name: 'HEALTH_BEAUTY_MARKET_POTENTIAL'
          }
        },
        {
          name: 'mpi_pet',
          title: 'Pets and Products Market Potential',
          report_request_data: {
            report_name: 'PETS_PRODUCTS_MARKET_POTENTIAL'
          }
        },
        {
          name: 'mpi_restaurant',
          title: 'Restaurant Market Potential',
          report_request_data: {
            report_name: 'RESTAURANT_MARKET_POTENTIAL'
          }
        },
        {
          name: 'mpi_retail',
          title: 'Retail Market Potential',
          report_request_data: {
            report_name: 'RETAIL_MARKET_POTENTIAL'
          }
        },
        {
          name: 'mpi_sports',
          title: 'Sports and Leisure Market Potential',
          report_request_data: {
            report_name: 'SPORTS_LEISURE_MARKET_POTENTIAL'
          }
        }
      ]
    },
    {
      categoryName: 'Tapestry Segmentation',
      value: [
        {
          name: 'tapestry_profileNEW',
          title: 'Tapestry Segmentation Area Profile',
          report_request_data: {
            report_name: 'TAPESTRY_SEGMENTATION_AREA_PROFILE'
          }
        }
      ]
    },
  ],
  CA_CATEGORIES : [
    {
      categoryName: 'Summary Reports',
      value: [
        {
          name: 'AgeSexCanada',
          title: 'Age By Sex Canada',
          report_request_data: {
            report_name: 'AGE_SEX_CANADA'
          }
        },
        {
          name: 'DEP65plus',
          title: 'Age 65+ Profile Canada',
          report_request_data: {
            report_name: 'DEP_AGE_65_PROFILE_CANADA'
          }
        },
        {
          name: 'DEPMarketProfile',
          title: 'Market Profile Canada',
          report_request_data: {
            report_name: 'DEP_MARKET_PROFILE_CANADA'
          }
        },
        {
          name: 'DEPOccupation',
          title: 'Occupation Profile Canada',
          report_request_data: {
            report_name: 'DEP_OCCUPATION_PROFILE_CANADA'
          }
        },
        {
          name: 'DetailIncCanada',
          title: 'Detailed Income Profile Canada',
          report_request_data: {
            report_name: 'DETAILED_INCOME_PROFILE_CANADA'
          }
        },
        {
          name: 'FamilyCanada',
          title: 'Family Report Canada',
          report_request_data: {
            report_name: 'FAMILY_REPORT_CANADA'
          }
        },
        {
          name: 'HousingCanada',
          title: 'Housing Profile Canada',
          report_request_data: {
            report_name: 'HOUSE_PROFILE_CANADA'
          }
        },
        {
          name: 'LangEthCanada',
          title: 'Language and Ethnicity Profile Canada',
          report_request_data: {
            report_name: 'LANGUAGE_AND_ETHNICITY_PROFILE_CANADA'
          }
        }
      ]
    },
    {
      categoryName: 'Prizm Segmentation',
      value: [
        {
          name: 'Prizm_Profile',
          title: 'Prizm Segmentation Area Report',
          report_request_data: {
            report_name: 'PRIZM_SEGMENTATION_AREA_REPORT'
          }
        }
      ]
    }
  ]

};



// WEBPACK FOOTER //
// ./src/app/constants/Reports.ts